/* Quick Shop modal controller + button injector */
(function() {
  // ---------- Modal shell ----------
  const modal = document.querySelector('[data-qs-modal]');
  if (!modal) return; // no shell on page → nothing to do

  const contentEl = modal.querySelector('[data-qs-content]');
  const closeEls = modal.querySelectorAll('[data-qs-close]');
  let lastFocused = null;

  function lockScroll(lock) {
    document.documentElement.classList.toggle('qs-lock', !!lock);
  }

  function closeQuickShop() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    contentEl.innerHTML = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch(e) {}
    }
  }

  async function openQuickShop(handle) {
    if (!handle) return;

    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockScroll(true);

    contentEl.innerHTML = '<div class="qs-loading" aria-live="polite">Loading…</div>';

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}products/${encodeURIComponent(handle)}?view=quick-shop`;

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      contentEl.innerHTML = html;
      wireUpInjectedContent();
      const dialog = modal.querySelector('.qs-dialog');
      dialog && dialog.focus({ preventScroll: true });
    } catch (err) {
      console.error('[Quick Shop] load failed:', err);
      contentEl.innerHTML = '<div class="qs-error">Sorry, something went wrong. Please try again.</div>';
    }
  }

  function wireUpInjectedContent() {
    // Media thumbs → swap main image
    contentEl.querySelectorAll('.qs-thumb').forEach(btn => {
      btn.addEventListener('click', () => {
        const src = btn.getAttribute('data-qs-image');
        const main = contentEl.querySelector('.qs-media-main img');
        if (src && main) main.setAttribute('src', src);
      });
    });

    // Variant pills → sync variant select
    const variantSelect = contentEl.querySelector('.qs-variant-select');
    if (variantSelect) {
      contentEl.querySelectorAll('.qs-option__radio').forEach(radio => {
        radio.addEventListener('change', () => {
          const groups = Array.from(contentEl.querySelectorAll('.qs-option__values'));
          const parts = groups.map(g => {
            const checked = g.querySelector('input.qs-option__radio:checked');
            return checked ? checked.value : '';
          }).filter(Boolean);

          const title = parts.join(' / ');
          const match = Array.from(variantSelect.options).find(o => o.text.trim().startsWith(title));
          if (match) variantSelect.value = match.value;
        });
      });
    }

    // Qty controls
    const qtyInput = contentEl.querySelector('.qs-qty-input');
    const dec = contentEl.querySelector('[data-qs-qty-decrease]');
    const inc = contentEl.querySelector('[data-qs-qty-increase]');
    if (qtyInput && dec && inc) {
      dec.addEventListener('click', () => {
        const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
      inc.addEventListener('click', () => {
        const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = v;
      });
    }
  }

  // ---------- Global event delegation ----------
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.qs-trigger-button');
    if (trigger) {
      e.preventDefault();
      const handle = trigger.getAttribute('data-qs-handle');
      openQuickShop(handle);
      return;
    }
    if (e.target.closest('[data-qs-close]')) {
      e.preventDefault();
      closeQuickShop();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) {
      e.preventDefault();
      closeQuickShop();
    }
  });

  // ---------- Button injector (works even if Liquid didn’t add one) ----------
  function extractHandleFromLink(linkEl) {
    if (!linkEl) return null;
    const href = linkEl.getAttribute('href') || '';
    const m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // NEW: put Quick Shop and Add to cart in one row
  function injectButtons(rootEl = document) {
    const cards = rootEl.querySelectorAll('.product-card-wrapper, .card-wrapper');
    cards.forEach(card => {
      // If we already organized this card, skip
      if (card.querySelector('.qs-actions-row')) return;

      // Get handle from card link
      const link = card.querySelector('a[href*="/products/"]');
      const handle = extractHandleFromLink(link);
      if (!handle) return;

      // Find theme quick-add (Add to cart) if present
      const quickAdd = card.querySelector('.quick-add');

      // Build Quick Shop wrapper/button (create only if not present)
      let qsWrap = card.querySelector('.qs-card-actions');
      if (!qsWrap) {
        qsWrap = document.createElement('div');
        qsWrap.className = 'qs-card-actions';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qs-trigger-button button button--secondary button--full-width';
        btn.setAttribute('data-qs-handle', handle);
        btn.setAttribute('aria-label', 'Quick shop');
        btn.textContent = 'QUICK SHOP';
        qsWrap.appendChild(btn);
      }

      // Create a single actions row and move both controls into it
      const row = document.createElement('div');
      row.className = 'qs-actions-row';

      if (quickAdd) {
        // Insert the row where quick-add currently lives, then move both in
        quickAdd.parentNode.insertBefore(row, quickAdd);
        row.appendChild(quickAdd);
        row.appendChild(qsWrap);
      } else {
        // Fallback placement at bottom of card content
        const bottomContent =
          card.querySelector('.card__content:last-child') || card;
        bottomContent.appendChild(row);
        row.appendChild(qsWrap);
      }
    });
  }

  // Initial run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => injectButtons());
  } else {
    injectButtons();
  }

  // MutationObserver to catch dynamic section loads (filtered collections, infinite scroll, etc.)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches('.product-card-wrapper, .card-wrapper, .product-grid, [data-section-id]')) {
          injectButtons(node);
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
// NEW: put Quick Shop and Add to cart in one row (safe for search/cards)
function injectButtons(rootEl = document) {
  const cards = rootEl.querySelectorAll('.product-card-wrapper, .card-wrapper');
  cards.forEach(card => {
    // Always work inside the card's content area (never the outer wrapper)
    const content =
      card.querySelector('.card__content:last-of-type') ||
      card.querySelector('.card__content') ||
      card.querySelector('.card__information')?.closest('.card__content');

    if (!content) return;                           // no safe container → skip
    if (content.querySelector('.qs-actions-row')) return; // already organized

    // Find handle from a product link inside this card
    const link = card.querySelector('a[href*="/products/"]');
    const href = link && link.getAttribute('href');
    const match = href && href.match(/\/products\/([^/?#]+)/);
    const handle = match ? match[1] : null;
    if (!handle) return;

    // Theme quick-add (if present) MUST be inside the content area
    const quickAdd = content.querySelector('.quick-add');

    // Build Quick Shop wrapper/button (create only if not present in content)
    let qsWrap = content.querySelector('.qs-card-actions');
    if (!qsWrap) {
      qsWrap = document.createElement('div');
      qsWrap.className = 'qs-card-actions';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qs-trigger-button button button--secondary button--full-width';
      btn.setAttribute('data-qs-handle', handle);
      btn.setAttribute('aria-label', 'Quick shop');
      btn.textContent = 'QUICK SHOP';
      qsWrap.appendChild(btn);
    }

    // Create one row and place both buttons INSIDE the content area
    const row = document.createElement('div');
    row.className = 'qs-actions-row';

    if (quickAdd) {
      content.insertBefore(row, quickAdd);
      row.appendChild(quickAdd);
      row.appendChild(qsWrap);
    } else {
      content.appendChild(row);
      row.appendChild(qsWrap);
    }
  });
}
